/** Prepare the native controls' first font paint without blocking startup on a failed asset. */
export async function prepareApplicationFonts(
  fonts: Pick<FontFaceSet, "load"> | undefined,
  timeoutMs = 1500,
): Promise<void> {
  if (!fonts) return;
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    const sample = "EN Suomi äö Å Українська їєґ Русский";
    const loaded = Promise.allSettled([
      fonts.load('400 16px "Inter Variable"', sample),
      fonts.load('600 16px "Inter Variable"', sample),
    ]);
    await Promise.race([
      loaded,
      new Promise<void>((resolve) => {
        timer = setTimeout(resolve, timeoutMs);
      }),
    ]);
  } catch {
    // The CSS fallback font keeps the application usable if loading cannot start.
  } finally {
    if (timer !== undefined) clearTimeout(timer);
  }
}
